

























































































import { Component, Vue } from 'vue-property-decorator';
import { mapState } from 'vuex';
import _ from 'lodash';
import { Spinner } from 'vue-image-spinner2';

@Component({
    name: 'show-files-modal',
    components: {
        Spinner,
    },
    computed: {
        ...mapState('files', ['allFiles', 'allFilesLoading', 'filesPerPage', 'filesPage', 'filesTotal']),
    },
})
export default class showFilesModal extends Vue {
    public allFiles!: any;
    public allFilesLoading!: any;
    public filesPage_: any = 1;
    public filesPerPage!: any;
    public filesPage!: any;
    public filesTotal!: any;
    public file_search: any = '';
    public cont = 0;

    allFilesHeaders = [
        { thClass: 'th', key: 'id', label: 'ID' },
        // { thClass: 'th', key: 'filename_download', label: 'Nombre' },
        { thClass: 'th', key: 'filename_download', label: 'Título' },
        { thClass: 'th', key: 'type', label: 'Tipo' },
        { thClass: 'th', key: 'filesize', label: 'Tamaño' },
        { thClass: 'th', key: 'edit', label: '' },
        { thClass: 'th', key: 'delete', label: '' },
    ];

    mounted() {
        this.getAllFiles();
    }

    onSelectImage(file: any) {
        this.setFile(file);
    }

    setPage(page: any) {
        // this.filesPage_ = page;
        this.filesPage_ = page || 1;
        this.getAllFiles(this.filesPage_, this.file_search);
    }

    setUrlSearch(search: string) {
        search = search.trim();
        this.getAllFiles(this.filesPage_, search);
    }

    getAllFiles(pagef = 1, search = null) {
        this.$store.dispatch('files/getAll', { pagef, search });
    }

    setFile(file: any) {
        this.cont++;
        if (this.cont == 1) {
            this.$emit('sendFile', file);
        }
        setTimeout(() => {
            this.cont = 0;
            this.$bvModal.hide('show-files-modal');
        }, 400);
    }
}
